import {
	EmailAttachmentFileS3,
	EmailThreadRecipients
} from "./../EmailThread/index";
import { Client, ClientContact } from "./../../Clients/index";
import { UserSettings, UserPermissionRole, UserData } from "./../../Users";
import {
	Attachment,
	AuditSyncSource,
	AuditTypes
} from "./../RecentActivityFeed/index";
import moment from "moment";

import { RecentActivityFeedType } from "../RecentActivityFeed";
import {
	EmailThreadParticipant,
	EmailThreadLabel,
	EmailThreadFile,
	EmailTracking
} from "../EmailThread";
import { MergeTagVariable } from "../../Documents";
import {
	ZomentumEntities,
	ZomentumEntityRequest,
	TableQueryFilter,
	Name,
	TableTimestampFilterKeys
} from "../../common";
import { OpportunityCostAndRevenueData } from "../../Opportunity";
import { OpportunityStage } from "../../Pipelines";
import { VendorUserData } from "../../Vendor/User";

export enum ESalesActivityType {
	TASK = "Task",
	MEETING = "Meeting",
	LOGCALL = "Call Log",
	LOGEMAIL = "Email Log",
	COMMENT = "Notes"
}

export enum CallOutcome {
	All = "all_outcome",
	Busy = "busy",
	AskedToCallLater = "asked_to_call_later",
	WrongNumber = "wrong_number",
	LeftVoicemail = "left_voicemail",
	Connected = "connected",
	Interested = "interested"
}

export enum TaskType {
	ToDo = "todo",
	FollowUp = "follow_up",
	Call = "call",
	Email = "email"
}

export enum SalesActivityPriority {
	All = "all_priority",
	High = "high",
	Medium = "medium",
	Low = "low"
}
export const SalesActivityPriorityMap: Record<SalesActivityPriority, number> = {
	[SalesActivityPriority.All]: -1,
	[SalesActivityPriority.High]: 2,
	[SalesActivityPriority.Medium]: 1,
	[SalesActivityPriority.Low]: 0
};

export enum SalesActivitySection {
	Pinned = "pinned",
	Overdue = "overdue",
	Upcoming = "upcoming",
	Completed = "completed",
	All = "all"
}

export enum SalesActivityUserViews {
	All = "All Activity",
	Owner = "My Activity",
	MyTask = "My Task",
	AllOpportunities = "All Opportunities",
	MyOpportunities = "My Opportunities"
}

export enum SalesActivityReminderType {
	Email = "email",
	InAppNotification = "in_app_notification"
}

export enum SalesActivityReminderUnit {
	Minute = "minute",
	Hour = "hour",
	Day = "day"
}

export enum SalesActivityUserType {
	User = "user",
	VendorUser = "vendor_user",
	ClientUser = "client_user",
	VendorClientUser = "vendor_client_user",
	Unknown = "unknown"
}

export enum SalesActivityInboxType {
	All = "all",
	Self = "self",
	Others = "others"
}

export const SalesActivityInboxTypeDisplayText = {
	[SalesActivityInboxType.All]: "All Inboxes",
	[SalesActivityInboxType.Self]: "My Inbox",
	[SalesActivityInboxType.Others]: "Other User's Inboxes"
};

export enum SalesActivityAllOwnerFilterType {
	All = "All Activity",
	Owner = "My Activity"
}

export enum SalesActivityOpportunityOwnerFilterType {
	All = "All Opportunities",
	Owner = "My Opportunities"
}

export enum SalesActivityNoteOwnerFilterType {
	All = "All Notes",
	Owner = "My Notes"
}

export enum SalesActivityTaskOwnerFilterType {
	All = "All Activity",
	Owner = "My Activity"
}

export enum SalesActivityMeetingOwnerFilterType {
	All = "All Activity",
	Owner = "My Activity"
}

export enum SalesActivityCallOwnerFilterType {
	All = "All Activity",
	Owner = "My Activity"
}

export enum SalesActivityEmailOwnerFilterType {
	All = "All Emails",
	Owner = "Sent by me"
}

export enum SalesActivityAutomationTriggerActionTypes {
	Created = "created",
	Updated = "updated",
	UpdateAll = "update_all",
	Send = "send"
}

export enum SalesActivityAutomationFilterCriteriaCombinerTypes {
	GlobalAnd = "global_and",
	GlobalOr = "global_or"
}

export type TriggerEntityListType = {
	key: TriggerActionEntityTypes;
	value: string;
};

export type TriggerTypeListType = {
	key: SalesActivityAutomationTriggerActionTypes;
	value: string;
};

export type ActionEntityListType = {
	key: TriggerActionEntityTypes;
	value: string;
};

export type ActionTypeListType = {
	key: SalesActivityAutomationTriggerActionTypes;
	value: string;
};

export class SalesActivityRequest {
	entity: ZomentumEntityRequest | null = null;
	next: string | null = null;
	paginate = false;
	filters: TableQueryFilter[] = new Array<TableQueryFilter>();
	relatedOpportunities?: string[];
	constructor(
		entity: ZomentumEntityRequest | null,
		next: string | null,
		paginate: boolean,
		filters: TableQueryFilter[],
		relatedOpportunities?: string[]
	) {
		this.entity = entity;
		this.next = next;
		this.paginate = paginate;
		this.filters = filters;
		this.relatedOpportunities = relatedOpportunities;
	}
}

export class SalesActivityPageRequest {
	next: string | null = null;
	previous: string | null = null;
	paginate = false;
	filters: TableQueryFilter[] = new Array<TableQueryFilter>();
	feedType: RecentActivityFeedType[] = new Array<RecentActivityFeedType>();
	feedSection: SalesActivitySection = SalesActivitySection.All;
	limit = 10;
	constructor(
		next: string | null,
		previous: string | null,
		paginate: boolean,
		filters: TableQueryFilter[],
		feedType: RecentActivityFeedType[],
		feedSection: SalesActivitySection,
		limit: number
	) {
		this.next = next;
		this.previous = previous;
		this.paginate = paginate;
		this.filters = filters;
		this.feedType = feedType;
		this.feedSection = feedSection;
		this.limit = limit;
	}
}

export class HistoryActivityRequest {
	page = 1;
	entity: ZomentumEntityRequest | null = null;
	limit = 5;

	constructor(
		page: number,
		entity: ZomentumEntityRequest | null,
		limit: number
	) {
		this.page = page;
		this.entity = entity;
		this.limit = limit;
	}
}

export class SalesActivityResponse {
	response: SalesActivity[] = new Array<SalesActivity>();
	next = "";
	total_count?: number;
	previous?: string;
	page_no?: number;
}

export class AggregateSalesActivityResponse {
	[SalesActivitySection.Pinned]: SalesActivityResponse =
		new SalesActivityResponse();
	[SalesActivitySection.Overdue]: SalesActivityResponse =
		new SalesActivityResponse();
	[SalesActivitySection.Upcoming]: SalesActivityResponse =
		new SalesActivityResponse();
	[SalesActivitySection.Completed]: SalesActivityResponse =
		new SalesActivityResponse();
}

export interface ClickedDetails {
	link: string;
	count: number;
}

export interface EmailTrackingDetails {
	clicked: number | null;
	clicked_detail: ClickedDetails[] | [];
	opened: number | null;
	opened_time_stamp: Date | null;
	replied_time_stamp: Date | null;
	clicked_time_stamp: Date | null;
	replied: number | null;
}

export enum SystemEmailTypes {
	DOCUMENT_SEND = "document_send",
	DOCUMENT_REMINDER = "document_reminder",
	DOCUMENT_EXPIRY = "document_expiry"
}

export class SalesActivity {
	account_id = "";
	author_id = "";
	date_time: Date = new Date();
	feed_details: SalesActivityFeedDetails = new SalesActivityFeedDetails();
	feed_type: RecentActivityFeedType = RecentActivityFeedType.All;
	id = "";
	priority: SalesActivityPriority = SalesActivityPriority.All;
	pinned = false;
	title = "";
	summary = "";
	tracking: EmailTrackingDetails | null = null;
	author?: UserData;
	attachments?: EmailLogAttachment[] | null;
}

export enum SalesActivityAutomationMetadataFilterValueTypes {
	PlainText = "plain_text",
	FixedListDropdown = "fixed_list_dropdown",
	DoubleNumber = "double_number",
	LongNumber = "long_number",
	IntNumber = "int_number",
	Date = "date"
}

export enum SalesActivityAutomationMetadataFilterOperator {
	Is = "is",
	IsNot = "is_not",
	IsInList = "is_in_list",
	IsNotInList = "is_not_in_list",
	IsEmpty = "is_empty",
	IsNotEmpty = "is_not_empty",
	HasChanged = "has_changed",
	HasNotChanged = "has_not_changed",
	HasChangedTo = "has_changed_to",
	HasChangedFrom = "has_changed_from",
	IsMoreThan = "is_more_than",
	IsLessThan = "is_less_than",
	IsBefore = "is_before",
	IsBeforeFixedDate = "is_before_fixed_date",
	IsAfter = "is_after",
	IsAfterFixedDate = "is_after_fixed_date",
	IsExactlyIn = "is_exactly_in",
	Contains = "contains",
	IsInNext = "is_in_next",
	IsAfterNext = "is_after_next",
	IsExactly = "is_exactly",
	IsExactlyFixedDate = "is_exactly_fixed_date",
	IsInLast = "is_in_last"
}

export const DateInputValueFilters = [
	SalesActivityAutomationMetadataFilterOperator.IsBefore,
	SalesActivityAutomationMetadataFilterOperator.IsAfter,
	SalesActivityAutomationMetadataFilterOperator.IsExactlyIn,
	SalesActivityAutomationMetadataFilterOperator.IsAfterNext,
	SalesActivityAutomationMetadataFilterOperator.IsInNext,
	SalesActivityAutomationMetadataFilterOperator.IsExactly
];

export const EmptyValueSalesActivityAutomationMetadataFilterOperators = [
	SalesActivityAutomationMetadataFilterOperator.IsEmpty,
	SalesActivityAutomationMetadataFilterOperator.IsNotEmpty,
	SalesActivityAutomationMetadataFilterOperator.HasChanged,
	SalesActivityAutomationMetadataFilterOperator.HasNotChanged
];

export const MultipleValueSalesActivityAutomationMetadataFilterOperators = [
	SalesActivityAutomationMetadataFilterOperator.IsInList,
	SalesActivityAutomationMetadataFilterOperator.IsNotInList
];

export enum SalesActivityAutomationActionUpdatableFieldValueType {
	// Dynamic values
	Fixed = "fixed",
	Custom = "custom",
	Owner = "owner",
	PartnerOwner = "partner_owner",
	Client = "client_company",
	Opportunity = "opportunity",
	PrimaryContact = "primary_contact",
	Contacts = "contacts",
	PoNumber = "po_number",
	ShipToAddress = "ship_to_address",
	VendorClient = "vendor_client_company",
	PartnerManager = "partner_manager",
	Partner = "partner",
	// Date values
	SameDay = "same_day",
	Minutes = "minutes",
	Hours = "hours",
	NextXDay = "in_next_x_days",
	PastXDay = "past_x_days",
	NextWeekDay = "next_week_day",
	PastWeekDay = "past_week_day",
	NextXWeek = "in_next_x_weeks",
	PastXWeek = "past_x_weeks",
	NextXMonth = "in_next_x_months",
	PastXMonth = "past_x_months",
	SkipWeekendsFutureDays = "in_next_x_days_skip_weekends",
	SkipWeekendsPastDays = "in_past_x_days_skip_weekends",
	SkipWeekendsFutureWeeks = "in_next_x_weeks_skip_weekends",
	SkipWeekendsPastWeeks = "in_past_x_weeks_skip_weekends",
	SkipWeekendsFutureMonths = "in_next_x_months_skip_weekends",
	SkipWeekendsPastMonths = "in_past_x_months_skip_weekends",
	PlainText = "plain_text"
}

export class SalesActivityAutomationMetadataFilter {
	filter_entity_type: ZomentumEntities | null = null;
	field_name: string | null = null;
	field_display_name: string | null = null;
	value_type: SalesActivityAutomationMetadataFilterValueTypes | null = null;
	valid_filter_operators: SalesActivityAutomationActionUpdatableFieldValue<SalesActivityAutomationMetadataFilterOperator>[] =
		new Array<
			SalesActivityAutomationActionUpdatableFieldValue<SalesActivityAutomationMetadataFilterOperator>
		>();
	valid_values:
		| SalesActivityAutomationActionUpdatableFieldValue<string>[]
		| null = null;
	filter_operator: SalesActivityAutomationActionUpdatableFieldValue<SalesActivityAutomationMetadataFilterOperator> | null =
		null;
	values: SalesActivityAutomationActionUpdatableFieldValue<string>[] =
		new Array<SalesActivityAutomationActionUpdatableFieldValue<string>>();
	filter_popover_visible = false;
	filter_search_criteria?: string;
	linked_entity_type: ZomentumEntities | null = null;
	linked_entity_types?: ZomentumEntities[] | null = null;

	public static getFilterRequestData = (
		filter: SalesActivityAutomationMetadataFilter
	) => {
		return {
			filter_entity_type: filter.filter_entity_type,
			field_name: filter.field_name,
			filter_operator: filter.filter_operator,
			values: filter.values
		};
	};
}

export enum AutomationEnums {
	ApprovalAutomation = "approval_automation",
	Payment = "payment_received_email",
	Draft = "draft",
	Enable = "enable",
	Webhook = "webhook_notification"
}

export interface WebhookHeaderResponse {
	key: string;
	value: string;
}

export interface WebhookConfigResponse {
	id: string;
	webhook_url: string;
	failure_notification_emails: string[];
	webhook_headers: WebhookHeaderResponse[];
	is_execution_blocked: boolean;
}

export type WebhookActionType = "create" | "update" | "delete";

export interface WebhookEntityActionCreateRequest {
	entityType: string;
	entityActionTypes: WebhookActionType[];
}

export interface WebhookConfigCreateRequest {
	webhookUrl: string;
	webhookHeaders?: WebhookHeaderResponse[];
	entityActions: WebhookEntityActionCreateRequest[];
	failureNotificationEmails: string[];
	isExecutionBlocked: boolean;
}

export class SendWebhookAutomationActionFields {
	webhook_url = "";
	failure_notification_emails: string[] = [];
	webhook_headers: WebhookHeaderResponse[] = [];
	webhook_config: WebhookConfigResponse | null = null;
}

export interface WebhookTestResponse {
	success: boolean;
	http_status?: number;
	response_body?: string;
	error_message?: string;
	payload?: Record<string, unknown>;
}

export type TriggerActionEntityTypes = AutomationEnums | ZomentumEntities;

export class SalesActivityAutomationMetadataRequest {
	trigger_action_type: SalesActivityAutomationTriggerActionTypes | null =
		null;
	trigger_entity_type: TriggerActionEntityTypes | null = null;
	constructor(
		trigger_action_type: SalesActivityAutomationTriggerActionTypes | null,
		trigger_entity_type: TriggerActionEntityTypes | null
	) {
		this.trigger_action_type = trigger_action_type;
		this.trigger_entity_type = trigger_entity_type;
	}
}

export class SalesActivityAutomationMetadataResponse {
	filters: SalesActivityAutomationMetadataFilter[] =
		new Array<SalesActivityAutomationMetadataFilter>();
	opportunity_stages: OpportunityStage[] = new Array<OpportunityStage>();
	merge_tags: MergeTagVariable[] = new Array<MergeTagVariable>();
}

export class SalesActivityAutomationActionUpdatableFieldValue<T> {
	display_value: string | null;
	id_value: T | null;
	value_type: SalesActivityAutomationActionUpdatableFieldValueType | null;
	group_type?: string | null;
	user_type?: string | null;
	constructor(
		display_value: string | null,
		id_value: T | null,
		value_type: SalesActivityAutomationActionUpdatableFieldValueType | null,
		user_type?: string | null
	) {
		this.id_value = id_value;
		this.display_value = display_value;
		this.value_type = value_type;
		this.user_type = user_type;
	}
}

export enum SalesActivityAutomationActionUpdatableFieldActionType {
	CreateOrReplace = "create_or_replace",
	AddToList = "add_to_list",
	RemoveFromList = "remove_from_list",
	Unset = "unset"
}

export enum SalesActivityAutomationActionRichFieldDateType {
	SameDay = "same_day",
	FutureDay = "future_day",
	PastDay = "past_day",
	Custom = "custom"
}

export enum SalesActivityAutomationActionRichFieldDateUnit {
	Day = "day",
	Week = "week",
	Month = "month"
}

export class SalesActivityAutomationActionUpdatableField {
	display_name = "";
	field_action_type: SalesActivityAutomationActionUpdatableFieldActionType | null =
		null;
	field_name = "";
	values: SalesActivityAutomationActionUpdatableFieldValue<string>[] =
		new Array<SalesActivityAutomationActionUpdatableFieldValue<string>>();
	front_end_display_is_enabled = false;

	constructor(
		display_name: string,
		field_action_type: SalesActivityAutomationActionUpdatableFieldActionType | null,
		field_name: string,
		values: SalesActivityAutomationActionUpdatableFieldValue<string>[],
		front_end_display_is_enabled: boolean
	) {
		this.display_name = display_name;
		this.field_action_type = field_action_type;
		this.field_name = field_name;
		this.values = values;
		this.front_end_display_is_enabled = front_end_display_is_enabled;
	}
}

export class SalesActivityAutomationActionEmailFields {
	account_id = "";
	subject = "";
	body = "";
	from: SalesActivityAutomationActionUpdatableFieldValue<string> =
		new SalesActivityAutomationActionUpdatableFieldValue<string>(
			null,
			null,
			null
		);
	to: SalesActivityAutomationActionUpdatableFieldValue<string>[] = new Array<
		SalesActivityAutomationActionUpdatableFieldValue<string>
	>();
	cc: SalesActivityAutomationActionUpdatableFieldValue<string>[] = new Array<
		SalesActivityAutomationActionUpdatableFieldValue<string>
	>();
	bcc: SalesActivityAutomationActionUpdatableFieldValue<string>[] = new Array<
		SalesActivityAutomationActionUpdatableFieldValue<string>
	>();
	file_ids: SalesActivityAutomationActionUpdatableFieldValue<string>[] =
		new Array<SalesActivityAutomationActionUpdatableFieldValue<string>>();
	s3_file_ids: EmailAttachmentFileS3[] = new Array<EmailAttachmentFileS3>();
	tracking: EmailTracking | null = null;
	should_replace_with_empty_string = true;
	use_default_email = true;
}

export class SendDocumentAutomationActionFields {
	from: EmailThreadRecipients = new EmailThreadRecipients();
	to?: SalesActivityAutomationActionUpdatableFieldValue<string>[] = new Array<
		SalesActivityAutomationActionUpdatableFieldValue<string>
	>();
	cc: SalesActivityAutomationActionUpdatableFieldValue<string>[] = new Array<
		SalesActivityAutomationActionUpdatableFieldValue<string>
	>();
	bcc: SalesActivityAutomationActionUpdatableFieldValue<string>[] = new Array<
		SalesActivityAutomationActionUpdatableFieldValue<string>
	>();
	file_ids: SalesActivityAutomationActionUpdatableFieldValue<string>[] =
		new Array<SalesActivityAutomationActionUpdatableFieldValue<string>>();
	s3_file_ids: EmailAttachmentFileS3[] = new Array<EmailAttachmentFileS3>();
	// 	SalesActivityAutomationActionUpdatableFieldValue<string>
	// >();
	subject = "";
	body = "";
	should_replace_with_empty_string = true;
	attach_document? = false;
	attach_signing_log? = false;
	attach_payment_log? = false;
	attach_product_list? = false;
}

export class SalesActivityAutomationActionDetails {
	updatable_fields: SalesActivityAutomationActionUpdatableField[] =
		new Array<SalesActivityAutomationActionUpdatableField>();
	email_fields: SalesActivityAutomationActionEmailFields =
		new SalesActivityAutomationActionEmailFields();
	send_document_fields: SendDocumentAutomationActionFields =
		new SendDocumentAutomationActionFields();
	webhook_fields: SendWebhookAutomationActionFields =
		new SendWebhookAutomationActionFields();
}

export class SalesActivityAutomationAction {
	action_type: SalesActivityAutomationTriggerActionTypes | null = null;
	entity_type: TriggerActionEntityTypes | null = null;
	action_details: SalesActivityAutomationActionDetails =
		new SalesActivityAutomationActionDetails();
	action_popover_visible = false;
}

export class SalesActivityAutomation {
	id = "";
	company_id = "";
	deleted = false;
	created: Date = new Date();
	updated: Date = new Date();
	creator_user_id = "";
	allow_rule_trigger = false;
	creator_user: UserData | VendorUserData = new UserData();
	trigger_entity_type: TriggerActionEntityTypes | null = null;
	trigger_action_type: SalesActivityAutomationTriggerActionTypes | null =
		null;
	filter_criteria: SalesActivityAutomationMetadataFilter[] =
		new Array<SalesActivityAutomationMetadataFilter>();
	filter_groups?: AutomationFilterMetadataV2[][] = [];
	is_enabled = false;
	filter_criteria_combiner: SalesActivityAutomationFilterCriteriaCombinerTypes | null =
		null;
	actions: SalesActivityAutomationAction[] =
		new Array<SalesActivityAutomationAction>();
	title = "";
	description = "";
	trigger_popover_visible = false;
	times_triggered?: number = 0;
	last_triggered?: Date = new Date();
	is_system_generated?: boolean = false;
}

export type IAutomationAutomationMetadataFilter = Omit<
	SalesActivityAutomationMetadataFilter,
	"filter_entity_type"
>;
export class AutomationFiltersFieldsValues
	implements IAutomationAutomationMetadataFilter
{
	field_name: string | null = null;
	field_display_name: string | null = null;
	value_type: SalesActivityAutomationMetadataFilterValueTypes | null = null;
	valid_filter_operators: SalesActivityAutomationActionUpdatableFieldValue<SalesActivityAutomationMetadataFilterOperator>[] =
		new Array<
			SalesActivityAutomationActionUpdatableFieldValue<SalesActivityAutomationMetadataFilterOperator>
		>();
	valid_values:
		| SalesActivityAutomationActionUpdatableFieldValue<string>[]
		| null = null;
	filter_operator: SalesActivityAutomationActionUpdatableFieldValue<SalesActivityAutomationMetadataFilterOperator> | null =
		null;
	values: SalesActivityAutomationActionUpdatableFieldValue<string>[] =
		new Array<SalesActivityAutomationActionUpdatableFieldValue<string>>();
	filter_popover_visible = false;
	filter_search_criteria?: string;
	linked_entity_type: ZomentumEntities | null = null;
	linked_entity_types?: ZomentumEntities[] | null = null;

	public static getFilterRequestData = (
		filter: AutomationFiltersFieldsValues
	) => {
		return {
			field_name: filter.field_name,
			filter_operator: filter.filter_operator,
			values: filter.values
		};
	};
}
export class AutomationFilterMetadataV2 {
	filter_entity_type: ZomentumEntities | null = null;
	fields_and_values: AutomationFiltersFieldsValues[] = [];
}

export class PartialAutomationFilterMetadataV2 {
	filter_entity_type: ZomentumEntities | null = null;
	fields_and_values: Partial<AutomationFiltersFieldsValues>[] = [];
}

export interface RelatedOpportunityInformation {
	id: string;
	name: string;
	primary_client_user: ClientContact | null;
	linked_client_users: ClientContact[];
	estimated_value: number | null;
	client: Partial<Client>;
	total?: OpportunityCostAndRevenueData;
	owner_id?: string;
	is_onboarding_entity?: boolean;
}

export interface RelatedClientInformation extends Partial<Client> {
	primary_client_user: ClientContact;
	owner_id?: string;
	is_demo_client?: boolean;
}

export interface SalesActivityFeedSharingDetails {
	source: "vendor" | "partner";
	creator_user_id: string;
	is_editable: boolean;
}

export class SalesActivityFeedDetails {
	account_id = "";
	author_id = "";
	author?: UserData;
	bcc: EmailThreadParticipant[] = new Array<EmailThreadParticipant>();
	body = "";
	body_updated: Date = new Date();
	cc: EmailThreadParticipant[] = new Array<EmailThreadParticipant>();
	date = 0;
	draft_ids: string[] = new Array<string>();
	email_id = "";
	email_ids_to_fetch: string[] = [];
	files: EmailThreadFile[] = new Array<EmailThreadFile>();
	file_ids: string[] = new Array<string>();
	from: EmailThreadParticipant = new EmailThreadParticipant();
	has_attachments = false;
	description = "";
	date_time: Date = new Date();
	end_date_time: Date = new Date();
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	entity_obj?:
		| RelatedOpportunityInformation
		| RelatedClientInformation
		| null;
	feed_section?: SalesActivitySection;
	feed_type: RecentActivityFeedType | null = null;
	first_message_date_time: Date = new Date();
	id = "";
	labels: EmailThreadLabel[] = new Array<EmailThreadLabel>();
	last_message_time_stamp: Date = new Date();
	message_ids: string[] = new Array<string>();
	object = "";
	participants: EmailThreadParticipant[] =
		new Array<EmailThreadParticipant>();
	reply_to: EmailThreadParticipant[] = new Array<EmailThreadParticipant>();
	snippet = "";
	starred = false;
	system_email?: SystemEmailTypes;
	to: EmailThreadParticipant[] = new Array<EmailThreadParticipant>();
	unread = false;
	version = 0;
	is_all_day = false;
	outcome: CallOutcome | string | null = null;
	notes = "";
	priority: SalesActivityPriority | null = null;
	pinned = false;
	task_type: TaskType | null = null;
	collaborator_ids: string[] = new Array<string>();
	attendees: SalesActivityAttendee[] = new Array<SalesActivityAttendee>();
	all_reminder_details: SalesActivityReminder[] =
		new Array<SalesActivityReminder>();
	is_marked_completed = false;
	completed_at: Date | null = null;
	subject = "";
	title = "";
	meeting_title = "";
	summary = "";
	location?: string;
	attachments?: Attachment[];
	is_email_log_body_html_present?: boolean;
	email_person_details?: LogEmailPersonDetails;
	sharing_details: SalesActivityFeedSharingDetails | null = null;
}

export class SalesActivityReminder {
	reminder_type: SalesActivityReminderType | null = null;
	reminder_interval = 0;
	sales_activity_reminder_unit: SalesActivityReminderUnit | null = null;
}

export class SalesActivityAttendee {
	attendee_id: string | null = "";
	attendee_type: SalesActivityUserType | null = null;
	email?: string;
	constructor(
		attendee_id: string | null,
		attendee_type: SalesActivityUserType | null,
		email?: string
	) {
		this.attendee_id = attendee_id;
		this.attendee_type = attendee_type;
		if (email) {
			this.email = email;
		}
	}
}

export class LogEmailFormValues {
	title = "";
	description = "";
	date: moment.Moment = moment();
	time: moment.Moment = moment();
	author_id = "";
	relation: ZomentumEntities | null = null;
	opportunity = "";
	client = "";
	client_company = "";
	company = "";
	vendor_opportunity = "";
	vendor_client_company = "";
}

export class AddLogEmailRequest {
	title = "";
	description = "";
	date_time: Date = new Date();
	author_id = "";
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
}

export class LogCallFormValues {
	title = "";
	description = "";
	date: moment.Moment = moment();
	time: moment.Moment = moment();
	outcome: string | null = null;
	author_id = "";
	relation: ZomentumEntities | null = null;
	opportunity = "";
	client = "";
	client_company = "";
	company = "";
	vendor_opportunity = "";
	vendor_client_company = "";
}

export class AddLogCallRequest {
	title = "";
	description = "";
	outcome: string | null = null;
	date_time: Date = new Date();
	author_id = "";
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
}
export class MeetingFormValues {
	title = "";
	description = "";
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	start_date: moment.Moment = moment();
	start_time: moment.Moment = moment();
	end_date: moment.Moment = moment();
	end_time: moment.Moment = moment();
	duration: number | null = null;
	duration_unit: SalesActivityReminderUnit | null = null;
	notes = "";
	author_id = "";
	relation: ZomentumEntities | null = null;
	opportunity = "";
	client = "";
	client_company = "";
	company = "";
	attendees: string[] = new Array<string>();
	location?: string;
	reminder_count = 0;
	reminder_enabled = false;
	reminder_interval: number[] = new Array<number>();
	reminder_unit: SalesActivityReminderUnit[] =
		new Array<SalesActivityReminderUnit>();
	reminders: Array<{
		number: number;
		selection: SalesActivityReminderUnit;
	}> = [];
	vendor_opportunity = "";
	vendor_client_company = "";
}

export enum MeetingClashStatus {
	Clashing = "clashing",
	Available = "available"
}
export interface MeetingClashStatusResponse {
	readonly status: MeetingClashStatus;
}

export interface FetchClashStatusInput {
	readonly startTime: number;
	readonly endTime: number;
	readonly id: string;
}

export class AddMeetingRequest {
	title = "";
	meeting_title = "";
	description = "";
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	date_time: Date = new Date();
	end_date_time: Date = new Date();
	is_all_day = false;
	notes = "";
	author_id = "";
	attendees: SalesActivityAttendee[] = new Array<SalesActivityAttendee>();
	location?: string;
	all_reminder_details: SalesActivityReminder[] =
		new Array<SalesActivityReminder>();
}

export class SalesActivityCommentFormValues {
	body = "";
	pinned = false;
	author_id = "";
	relation: ZomentumEntities | null = null;
	opportunity = "";
	client = "";
	client_company = "";
	company = "";
	entity_id = "";
	vendor_opportunity = "";
	vendor_client_company = "";
	entity_type: ZomentumEntities | null = null;
}

export class AddSalesActivityCommentRequest {
	body = "";
	pinned = false;
	entity_id = "";
	author_id = "";
	entity_type: ZomentumEntities | null = null;
	attachments: Attachment[] = new Array<Attachment>();
}

export class TaskFormValues {
	title = "";
	description = "";
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	date: moment.Moment = moment();
	skip_weekends = false;
	time: moment.Moment = moment();
	due_time: moment.Moment = moment();
	author_id = "";
	relation: ZomentumEntities | null = null;
	opportunity = "";
	client = "";
	client_company = "";
	collaborator_ids: string[] = new Array<string>();
	priority: SalesActivityPriority | null = null;
	is_marked_completed = false;
	completed_at: moment.Moment | null = null;
	task_type: TaskType | null = null;
	vendor_client_company = "";
	company = "";
	vendor_opportunity = "";
}

export class AddTaskRequest {
	title = "";
	description = "";
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	date_time: Date = new Date();
	author_id = "";
	collaborator_ids: string[] = new Array<string>();
	priority: SalesActivityPriority | null = null;
	is_marked_completed = false;
	completed_at: Date | null = null;
	task_type: TaskType | null = null;
}

export type SalesActivityAutomationFilterCreate = Omit<
	SalesActivityAutomationMetadataFilter,
	| "field_display_name"
	| "value_type"
	| "valid_filter_operators"
	| "valid_values"
	| "filter_search_criteria"
	| "filter_popover_visible"
	| "linked_entity_type"
>;

export class AddSalesActivityAutomationRequest {
	trigger_entity_type: TriggerActionEntityTypes | null = null;
	trigger_action_type: SalesActivityAutomationTriggerActionTypes | null =
		null;
	filter_criteria: SalesActivityAutomationFilterCreate[] =
		new Array<SalesActivityAutomationFilterCreate>();
	is_enabled = false;
	filter_criteria_combiner: SalesActivityAutomationFilterCriteriaCombinerTypes | null =
		null;
	actions: SalesActivityAutomationAction[] =
		new Array<SalesActivityAutomationAction>();
	title = "";
	description = "";
	allow_rule_trigger = false;
	filter_groups?: AutomationFilterMetadataV2[][] = [];
	constructor(salesActivityAutomation: SalesActivityAutomation) {
		this.trigger_entity_type = salesActivityAutomation.trigger_entity_type;
		this.trigger_action_type = salesActivityAutomation.trigger_action_type;
		this.filter_criteria = salesActivityAutomation.filter_criteria;
		this.is_enabled = salesActivityAutomation.is_enabled;
		this.allow_rule_trigger = salesActivityAutomation.allow_rule_trigger;
		this.filter_criteria_combiner =
			salesActivityAutomation.filter_criteria_combiner;
		this.actions = salesActivityAutomation.actions;
		this.title = salesActivityAutomation.title;
		this.description = salesActivityAutomation.description;
		this.filter_groups = salesActivityAutomation.filter_groups;
	}
}
export class EditSalesActivityAutomationRequest {
	id = "";
	trigger_entity_type: TriggerActionEntityTypes | null = null;
	trigger_action_type: SalesActivityAutomationTriggerActionTypes | null =
		null;
	filter_criteria: SalesActivityAutomationFilterCreate[] =
		new Array<SalesActivityAutomationFilterCreate>();
	is_enabled = false;
	filter_criteria_combiner: SalesActivityAutomationFilterCriteriaCombinerTypes | null =
		null;
	actions: SalesActivityAutomationAction[] =
		new Array<SalesActivityAutomationAction>();
	title = "";
	allow_rule_trigger = false;
	description = "";
	filter_groups?: AutomationFilterMetadataV2[][] = [];
	constructor(salesActivityAutomation: SalesActivityAutomation) {
		this.id = salesActivityAutomation.id;
		this.trigger_entity_type = salesActivityAutomation.trigger_entity_type;
		this.trigger_action_type = salesActivityAutomation.trigger_action_type;

		this.filter_criteria =
			salesActivityAutomation.filter_criteria.map<SalesActivityAutomationFilterCreate>(
				filter => ({
					filter_entity_type: filter.filter_entity_type,
					field_name: filter.field_name,
					filter_operator: filter.filter_operator,
					values: filter.values
				})
			);

		this.is_enabled = salesActivityAutomation.is_enabled;
		this.filter_criteria_combiner =
			salesActivityAutomation.filter_criteria_combiner;
		this.actions = salesActivityAutomation.actions;
		this.title = salesActivityAutomation.title;
		this.description = salesActivityAutomation.description;
		this.filter_groups = salesActivityAutomation.filter_groups;
	}
}

export class SalesActivityAutomationResponse {
	data: SalesActivityAutomation[] = new Array<SalesActivityAutomation>();
}

export class HistoryActivityResponse {
	data: HistoryActivity[] | PaymentHistoryActivity[] =
		new Array<HistoryActivity>();
	filtered_count_map: any | null;
	next: number | null = null;
}

export interface AuditLogAuthor {
	bot_user_source: any;
	company_id: string;
	created: Date;
	email: string;
	fc_token: any;
	id: string;
	is_disabled: boolean;
	name: Name;
	phone: null;
	role: null;
	roles: UserPermissionRole;
	updated: Date;
	user_settings: UserSettings;
}

export enum HistoryActivitiesKeys {
	ChangedData = "changed_data",
	AddedData = "added_data",
	DeletedData = "deleted_data"
}

export enum AuditStatus {
	Success = "SUCCESS",
	Error = "ERROR",
	PartialSuccess = "PARTIAL_SUCCESS",
	NoAction = "NO_ACTION",
	InProgress = "IN_PROGRESS"
}

export class HistoryActivity {
	id = "";
	created: Date = new Date();
	updated: Date = new Date();
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	author_id = "";
	audit_type: AuditTypes | null = null;
	author_type = "";
	author: AuditLogAuthor | null = null;
	author_company_name: string | null = null;
	shared_with_company_name: string | null = null;
	changed_data: CommonData[] = new Array<CommonData>();
	added_data: CommonData[] = new Array<CommonData>();
	deleted_data: CommonData[] = new Array<CommonData>();
	sync_source: AuditSyncSource | null = null;
	data_entity_name: string | null = null;
	data_entity_id = "";
	data_entity_type: ZomentumEntities | null = null;
	company_id = "";
	action_status: AuditStatus = AuditStatus.NoAction;
	audit_message?: string;
	changed_by_automation?: string | null = null;
}

export interface PaymentHistoryActivity {
	created: Date;
	description: string;
	entity_title: string;
	document_id: string;
	entity_type: string;
	sync_type: string;
	status: string;
}

export interface CommonData {
	existing_value?: string | null;
	key: string;
	value: string;
}

export interface ActivityDetails {
	title: string;
	details: string[];
	existingDetails?: string[];
}

export class GetOneSaleActivityRequest {
	salesActivityEntityId = "";
	SalesActivityEntityType: RecentActivityFeedType | null = null;
	constructor(
		salesActivityEntityId: string,
		salesActivityEntityType: RecentActivityFeedType | null
	) {
		this.salesActivityEntityId = salesActivityEntityId;
		this.SalesActivityEntityType = salesActivityEntityType;
	}
}

export interface FilterPopoverFormValues {
	date_time?: TableTimestampFilterKeys;
	estimated_close_date?: TableTimestampFilterKeys;
	custom_start_date?: Date;
	custom_end_date?: Date;
	priority?: SalesActivityPriority;
	outcome?: CallOutcome;
	author_id?: SalesActivityUserViews;
	owner_user_id?: SalesActivityUserViews;
	opportunity_ids?: string[];
	comment_attachments?: boolean;
	inbox_type?: SalesActivityInboxType;
}

export enum AuditLogsCategories {
	All = "all",
	PSA = "psa",
	Self = "self",
	PreSalesSource = "pre_sales_source",
	AccountingSource = "accounting_source",
	VendorSource = "vendor_source",
	CustomDistributorSource = "custom_distributor_source",
	PaymentsSource = "payment_source"
}

export interface FetchCategoryBasedAuditLogsRequest {
	log_source: AuditLogsCategories;
	page: number;
	limit: number;
	filter: TableQueryFilter[];
	sync_source?: string;
}

export interface FetchCustomDistributorAuditLogsRequest {
	log_source: AuditLogsCategories;
	page: number;
	limit: number;
	filter: TableQueryFilter[];
	customDistributorId: string;
}

export interface RetryFailedAuditLogsRequest {
	entity_id: string;
	entity_type: ZomentumEntities | null;
	audit_type: AuditTypes | null;
}

export interface SalesActivityAuditLogEntities {
	entity_id: string;
	entity_name: string | null;
}

export interface SalesActivityAutomationAuditLogSuccessFailureDetails {
	entity_action_type: ZomentumEntities;
	action_type: SalesActivityAutomationTriggerActionTypes;
	error_message: string | null;
	entities: SalesActivityAuditLogEntities[];
}

export interface SalesActivityAutomationAuditLog {
	id: string;
	rule_id: string;
	created: Date;
	entity_id: string;
	entity_type: ZomentumEntities;
	entity_name: string | null;
	status: AuditStatus;
	success_failure_details:
		| SalesActivityAutomationAuditLogSuccessFailureDetails[]
		| null;
	triggered_by_automation?: string | null;
}

export interface SalesActivityAutomationAuditLogsRequest {
	rule_id: string;
	page: number;
	limit: number;
}

export interface SalesActivityAutomationAuditLogsResponse {
	data: SalesActivityAutomationAuditLog[];
	filtered_count_map: null;
}

export interface MeetingTimeDateRange {
	start_time: moment.Moment | null;
	start_date: moment.Moment | null;
	end_date: moment.Moment | null;
	end_time: moment.Moment | null;
}

export interface SendEmailDrawerUploadAttachmentResponse {
	upload_url: string;
	file_id: string;
}

export interface EmailLogAttachment {
	id: string;
	file_name: string;
	mime_type: string;
	size_bytes: number;
}

export interface LogEmailPersonDetails {
	from: EmailThreadParticipant | null;
	to: EmailThreadParticipant[];
	cc: EmailThreadParticipant[];
	bcc: EmailThreadParticipant[];
}

export interface LogEmailBodyRespone {
	date: Date;
	email_log_body_html: string | null;
	title: string;
	email_person_details: LogEmailPersonDetails | null;
	attachments: EmailLogAttachment[] | null;
}

export interface SelectedDocumentAndTemplate {
	selected_doc_type: string;
	selected_temp_type: string;
}

export enum CallLogOutComeValue {
	Busy = "Busy",
	AskedToCallLater = "Asked To Call Later",
	WrongNumber = "Wrong Number",
	LeftVoicemail = "Left Voicemail",
	Connected = "Connected",
	Interested = "Interested"
}

export interface CommonFunctionOpportunitySelectProps {
	disabled?: boolean;
}
export interface CommonFunctionClientSelectProps {
	disabled?: boolean;
}
export interface CommonFunctionUserSelectProps {
	disabled?: boolean;
}
export interface CommonFunctionFormItemsProps {
	opportunitySelect?: CommonFunctionOpportunitySelectProps;
	clientSelect?: CommonFunctionClientSelectProps;
	userSelect?: CommonFunctionUserSelectProps;
}

export enum SalesActivityFilterType {
	Status = "Status",
	Type = "Type",
	DueDate = "Due Date",
	Priority = "Priority"
}

export interface ConflictedMeetigs {
	id: string;
	title: string;
	description: string | null;
	start_time: moment.Moment;
	end_date_time: moment.Moment;
	nylas_acc_id: string;
	calendar_id: string;
	participants: null;
}
